import BaseAPI from "./BaseAPI";
import { announcementRoute } from "../routes";

/**
 * API client for announcement/team communication endpoints.
 * Extends BaseAPI with custom methods for acknowledgment.
 */
export default class AnnouncementAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, announcementRoute, "announcement");
    }

    /**
     * Get announcements that the current user hasn't acknowledged yet.
     *
     * @returns {Promise<Array>} Array of unacknowledged announcements
     */
    async ListUnacknowledged() {
        return this._request("get", this._url("/unacknowledged"));
    }

    /**
     * Get persistent announcements plus acknowledgement announcements that the
     * current user has not acknowledged.
     *
     * @returns {Promise<Array>} The current user's announcement feed
     */
    async ListFeed() {
        return this._request("get", this._url("/feed"));
    }

    /**
     * Acknowledge an announcement (mark as read).
     *
     * @param {string} id - Announcement ID to acknowledge
     * @returns {Promise<Object>} Acknowledgment result with timestamp
     */
    async Acknowledge(id) {
        const result = await this._request("post", this._url(`/${id}/acknowledge`));
        this._emit("acknowledge", id);
        return result;
    }
}
